// Diagnosis Types
export const DIAGNOSIS_TYPE = {
  PRINCIPLE: '745d4107-4b00-45bb-814c-535fdf16b968',
  SECONDARY: 'ce8704d9-9312-4ac4-82d2-919d4e41a753',
  ADMITTING: 'e03f3d1e-5eac-4258-8204-c24560fcdff4',
  DISCHARGE: '9bf97f56-e7fb-45e5-89e9-97da6ccbac91',
  DIFFERNTIAL: '6566288c-219d-428a-b71d-1a670e8cbdce'
};

// Claim Types
export const CLAIM_TYPE = {
  DENTAL: '7a897715-844f-4279-b00c-9076b033df00',
  INSTITUTIONAL: 'b9f28091-bbae-4ef9-858e-a9483ca72d46',
  OPTICAL: '1bcbfe5e-260e-4db6-8014-a94c680389e3',
  PHARMACY: 'ece3597a-4377-44a0-a939-447e447538a2',
  PROFESSIONAL: '6fc4332b-2ae3-4469-8358-6f75785098ae'
};

// Claim Sub Types
export const CLAIM_SUB_TYPE = {
  OUT_PATIENT: 'e2f392fb-2752-4061-8895-4a881a71c7ba',
  IN_PATIENT: '14f75e87-bb8f-4af9-967a-c816350c7db5',
  EMERGENCY: '17ae7ce3-8214-42c9-9fba-67195fd1cb1b'
};

// Pre Reasons
export const PRE_REASON = {
  OTHER: 'e3b75a8a-d7db-4ddb-bb11-7c1aa8f89cf2'
};

// Service Types
export const SERVICE_TYPE = {
  SCIENTIFIC_CODES: '5829d072-9b59-4595-b3be-3f8f061dec5b',
  MEDICATION_CODES: 'c2210885-b0c2-4402-816e-9cba8ad0b561',
  SERVICES: '912df5a9-c337-4f51-b5f6-22e4b37552f6',
  NUTRITION_CODES: '97f36ab7-c036-4e18-970f-fe7baf08308f',
  MEDICAL_DEVICES: '58a15d10-52e3-4f3d-9a25-0a0eb512f305',
  DOCTORS_OFFICE_VISIT: '89418e9e-d051-4dba-b85f-30ceca0f014a',
  COSMETIC_CODES: '962a97bd-d7f2-4fae-80cc-de16c6a36059',
  ORAL_HEALTH_OP: '783f37a9-caff-42ee-8396-fb999176ab8b',
  IMAGING: 'd2d68cd4-fc9d-4f3d-9b61-ccb3c254a528',
  LABORATORY: '8235861e-a646-4e1a-b22b-2ca3d0ec805b',
  HERBAL_AND_VITAMIN_CODES: 'b269f592-35e4-466b-be98-a583f7bd144a',
  TRANSPORTATION_SRCA: 'f1886d6d-6293-474b-b50d-71c433e78381',
  ORAL_HEALTH_IP: '35df1796-26ec-4e71-b221-4e4442bd8983',
  PROCEDURES: '00d94d2a-4e4a-441e-b3fa-dc5fd2ec664a',
  OTHER: 'b9e8b85f-1765-40e2-a2a5-24c0188aad17'
};

// Pharmacist Substitute
export const PHARMACIST_SUBSTITUTE = {
  OTHER: 'cfeb731f-f0fa-4fe5-b248-a15dee17b7e6'
};

// Eligibility Types
export const ELIGIBILITY_TYPE = {
  OFFLINE: 'c0675da0-fc9b-4f45-9385-93ae62f9e4fa',
  ONLINE: 'dab8f11c-388f-4da3-940e-dbdffb6e8453'
};

// Preauth Detail Types
export const PREAUTH_DETAIL_TYPE = {
  OFFLINE: 'c643ba6c-07b0-416f-a2f6-e28af0235f28',
  ONLINE: '771ba8f3-b5ff-4744-8d61-e53c39f7328e'
};

// Default users from the keycloak
export const DEFAULT_USERS = {
  SUPER_ADMIN: 'super.admin@tpa.com',
  PAYER: 'test.payer@tpa.com',
  PROVIDER: 'test.provider@tpa.com'
};

// Default service users from the keycloak
//ts-prune-ignore-next
export const DEFAULT_SERVICE_USERS = {
  TPA_DEVELOPMENT: 'service-account-tpa_development',
  ERP_TPA_DEVELOPMENT: 'service-account-erp_tpa_development',
};

// Default roles from the keycloak
export const DEFAULT_ROLES = {
  SUPER_ADMIN: 'super admin',
  PAYER: 'payer portal',
  PROVIDER: 'provider portal',
  PATIENT: 'patient portal'
};

// Default roles from the keycloak
export const DEFAULT_ROLES_ID = {
  PAYER: '6233e48d-7b01-4a6e-9309-998d0bb7a63a',
  PROVIDER: 'c483a43f-d071-48c4-b94d-1b4a7d3673d0',
  PATIENT: 'ade825e5-4c43-44be-9517-d550a5671f93'
  //PAYER: '40619660-dbe5-4907-a23a-357cfd7209bb',
  //PROVIDER: '97953a75-2ab4-44be-8a61-4fd444057e6d',
  //PATIENT: '15268601-63e9-42a9-a7a7-8e3f3cbe2aca'
};

// Billing Types
//ts-prune-ignore-next
export const BILLING_TYPE = {
  REIMBURSEMENT_BILLING: 'bde60c94-27cc-42c0-9f67-abcceeb369c8',
  DIRECT_BILLING: 'a18f046f-68dd-41d7-857f-2500206481fa'
};

// Relation Types
//ts-prune-ignore-next
export const RELATION_TYPE = {
  PRIMARY: '3193561b-652a-4bb8-83f3-d896543a9585'
};

export const BATCH_STATUS_VALUE = {
  CREATING: '1ffd9ff7-42fb-43d4-829a-c806e7e8a24f',
  POSTED: '5fbae0a2-04dc-4d93-9527-fdfe01bbc2a7',
  REVIEWED: '928d1a83-46be-46e7-ad93-f55ed3433023',
  REVIEWING: '61d5edb8-6b1a-4e66-8f16-7310d5b4cec7',
  SETTLED: '7aa911fe-4607-4d6e-8649-d4ac2f669f23',
  SETTLING: '4644ef94-9adf-4993-bc3b-95da7d186100',
  SUBMITTED: 'b2a75fef-dff8-48e6-aabf-07b79ceaeedf',
};

export const PROVIDER_BATCH_STATUS_VALUE = {
  CREATING: '2c382a03-ce97-43d2-bc5c-e19ffa046c7f',
  SUBMITTED: 'dd904723-1eb3-48de-aa42-cf5f1e277b8d',
  READY_SUBMISSION: 'f8914bd6-2fb1-4361-8241-5cde058621db'
};

export const DECISION_STATUS_VALUE = {
  DISAGREE: 'ea723535-b8f0-49df-80dc-1021f6900c5a',
  AGREE: '037bb7f8-e8a1-4184-afd0-8678ed4eeb93',
  PENDING: 'c38f33ba-9e01-4ebf-b13a-12a43328897d'
};